module.exports = __webpack_public_path__ + "images/checkbox-unselected27f59eca9edda813a7577ee9558d8321.svg";